import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propNumber, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import SlideSearchTopMySlideListItemUploaded from './SlideSearchTopMySlideListItemUploaded';
import SlideSearchTopMySlideListItemUploading from './SlideSearchTopMySlideListItemUploading';
import SlideSearchTopMySlideListItemWorking from './SlideSearchTopMySlideListItemWorking';
const SlideSearchTopMySlideListItem = (props) => {
    const { index, item, progress, type } = props;
    const { completeAt, convertedPageCount, pageCount } = item;
    const isWorking = (type === 'uploaded' && !completeAt) || type !== 'uploaded';
    return (_jsxs("li", Object.assign({ className: clsx('slide_list_item', isWorking && 'is-uploading'), "data-index": index }, { children: [type === 'uploaded' && !completeAt && (_jsx(SlideSearchTopMySlideListItemWorking, { convertedPageCount: convertedPageCount, pageCount: pageCount })), type === 'uploaded' && completeAt && (_jsx(SlideSearchTopMySlideListItemUploaded, { item: item })), type !== 'uploaded' && (_jsx(SlideSearchTopMySlideListItemUploading, { progress: progress }))] })));
};
SlideSearchTopMySlideListItem.propTypes = {
    index: propNumber().isRequired,
    item: propShape(),
    progress: propNumber(),
    type: propStr().isRequired,
};
SlideSearchTopMySlideListItem.defaultProps = {
    item: {},
    progress: 0,
};
export default SlideSearchTopMySlideListItem;
